<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Optimization Report'"
      [canGoBack]="true"
      [customBack]="fromGettingStarted ? 'getting-started' : null"
      [linkIcon]="'share'"
      [showLinkIcon]="currentView === 'results' && !!report"
      (linkAction)="shareReport()" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    @if (!loaded) {
      <div class="loading-container">
        <tidy-loader />
      </div>
    }

    @if (loaded && currentView === 'processing') {
      <tidy-card>
        <tidy-row>
          <tidy-text [header]="processingError ? 'Analysis Failed' : 'Analyzing Your Listing...'" />
        </tidy-row>

        @if (!processingError) {
          @if (currentStepMessage) {
            <tidy-row>
              <tidy-text [helper]="currentStepMessage" />
            </tidy-row>
          }

          <tidy-row [alignLastItemRight]="true" class="extra-top-padding">
            <tidy-text [body]="'Progress'" />
            <tidy-text [body]="progress + '%'" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding">
            <mat-progress-bar mode="determinate" [value]="progress" />
          </tidy-row>

          @for (step of stepsWithStatus; track step.key) {
            <div
              class="step-row"
              [class.step-completed]="step.status === 'completed'"
              [class.step-current]="step.status === 'current'"
              [class.step-pending]="step.status === 'pending'">
              @if (step.status === 'completed') {
                <img src="assets/svg/checkmark-circle-outline.svg" class="step-icon step-icon-completed" />
              } @else if (step.status === 'current') {
                <ion-spinner name="crescent" class="step-spinner" />
              } @else {
                <img [src]="step.icon" class="step-icon step-icon-pending" />
              }
              <span class="step-label">{{ step.label }}</span>
            </div>
          }
        }

        @if (processingError) {
          <tidy-row>
            <tidy-text [body]="processingError" />
          </tidy-row>
        }
      </tidy-card>

      @if (processingError && !invalidListingConnection && listingUrl) {
        <tidy-button [text]="'Try Again'" [action]="retryAnalysis" class="primary" />
      }
    }

    @if (currentView === 'results' && report) {
      <listing-optimizer-report
        [report]="report"
        [showHeader]="true"
        [historyMode]="false"
        [listing]="airbnbListing"
        (reportExpired)="handleReportExpired()" />

      @if (!fromMarketing) {
        <tidy-button [text]="'Done'" [action]="completeStep" class="primary" />
      }
    }
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
} @else {
  <ng-container *ngTemplateOutlet="content" />
}
